
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const ORDER_FIELDS_BASE = "/orderfields";
const buildUrl = (endpoint) => ORDER_FIELDS_BASE + endpoint;
const ApiName = "orderfields";

const orderFieldApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOrderFields: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}` }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getOrderFields', `${ApiName}`)
        }),
        getOrderFieldsSelect: builder.query({
            query: () => ({
                url: buildUrl(`/select`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Select`}]
        }),
        getOrderField: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        addOrderFields: builder.mutation({
            query: productFieldInfo => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body: productFieldInfo,
            }),
            invalidatesTags: [`${ApiName}`,`${ApiName}Select`],
        }),
        editOrderFields: builder.mutation({
            query: productFieldInfo => ({
                url: buildUrl(`/${productFieldInfo.id}`),
                method: 'PUT',
                body: productFieldInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`},{type: `${ApiName}Select`}],
        }),
        deleteOrderFields: builder.mutation({
            query: prop => ({
                url: buildUrl(`/${prop.id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}, {type: `${ApiName}Select`}],
        }),
    }),
});

export const {
    useGetOrderFieldsQuery,
    useGetOrderFieldQuery,
    useGetOrderFieldsSelectQuery,
    useAddOrderFieldsMutation,
    useEditOrderFieldsMutation,
    useDeleteOrderFieldsMutation
  } = orderFieldApiSlice;
